/*usage:
    <Tabs className="className" currentTabIndex={index} onTabChange={(index) => console.log(index)}>
        <Tab> a </Tab>
        <Tab> b </Tab>
        <Tab> c </Tab>
    </Tabs>
*/

import Tab from './tab';
import TabAnchor from './tabAnchor';
import Tabs from './tabs';

export { Tab, Tabs, TabAnchor };
